// @ts-nocheck
import * as React from "react";

const File: React.FC = () => {
    return (
        <svg
            focusable="false"
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path
                d="m21.79165,8.62498l-7,0a2,2 0 0 0 -2,2l0,16a2,2 0 0 0 2,2l12,0a2,2 0 0 0 2,-2l0,-11l-7,-7z"
                id="svg_1"
            />
            <polyline
                stroke="null"
                points="21.77080935239792,9.041646014899015 21.77080935239792,15.979145061224699 27.708313167095184,15.979145061224699 "
                id="svg_2"
            />
        </svg>
    );
};

export default React.memo(File);
